<template>
	<gmap-map
		:center="{
			lat: -34.8765154328281, 
			lng: 138.59312432614468,
		}"
		:zoom="14"
		map-type-id="roadmap"
		style="width: 100%; height: 500px"
		:options="{
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			disableDefaultUi: false,
			styles: [{ stylers: [{ saturation: -100 }] }],
		}"
	>
		<gmap-custom-marker
			v-for="(mark, index) in marker"
			:key="index"
			:marker="mark"
		>
			<img :src="marker_icon" height="50" />
		</gmap-custom-marker>
	</gmap-map>
</template>
<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker';

export default {
	data() {
		return {
			marker: [
				{
					lat: -34.8765154328281,
					lng: 138.59312432614468,
				},
				// {
				// 	lat: -34.813369105685744,
				// 	lng: 138.60717189586944,
				// },
			],
		};
	},

	props: {
		marker_icon: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {
		GmapCustomMarker,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

/* write SCSS here */
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/GoogleMap.vue